export default __webpack_public_path__ + "static/media/profile_female@2x.3076b605.png";